<!--
 * @Author: RYL
 * @Description: 添加变量公共组件
 * @Date: 2020-10-12 09:19:02
 * @LastEditTime: 2022-03-24 14:10:55
-->
<template>
  <div>
    <div style="margin-bottom: 20px; margin-top: 10px">
      <el-button v-if="Permission.indexOf(247) !== -1" type="primary" size="mini" @click="addParams"
        :disabled="templateId ? false : true">{{ $t("lang.collect.addVariable") }}</el-button>
      <slot name="slot"></slot>
    </div>
    <el-table size="mini" id="out-table" :data="paramsList" :header-cell-style="{ background: '#e4f1ff' }"
      :height="Height" @sort-change="tableSort">
      <el-table-column :label="$t('lang.collect.serialNumber')" align="center">
        <template slot-scope="scope">
          <span v-if="scope.$index !== 0" style="color: #409eff; font-size: 15px">{{ scope.$index }}</span>
        </template>
      </el-table-column>
      <el-table-column width="120px" :label="$t('lang.collect.variableName')" prop="name" sortable="custom">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.collect.unit')" width="100" v-if="templateType == 0" sortable="custom" prop="unit">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0 && scope.row.unit">{{ scope.row.unit | unitFormat }}</span>
          <span v-else-if="scope.$index !== 0 && !scope.row.unit">-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="templateType == 0" :label="$t('lang.collect.registertype')" min-width="130px">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            registerTypeObj[scope.row.registerType]
          }}</span>
        </template>
      </el-table-column>
      <el-table-column width="158px" v-if="templateType == 0" prop="registerAddress" sortable="custom"
        :label="$t('lang.collect.startaddress')">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            computedAddress(scope.row)
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="寄存器个数">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0"> {{scope.row.registerNum}}</span>
        </template>
      </el-table-column>-->
      <el-table-column v-if="templateType == 0" :label="$t('lang.collect.typeofdata')" width="160px">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            dataTypeObj[scope.row.dataType]
          }}</span>
        </template>
      </el-table-column>
      <!-- 从站id -->
      <el-table-column v-if="templateType == 0" prop="sid" sortable="custom" :label="$t('lang.terminalList.SlaveID')"
        width="100px">
        <template slot-scope="scope">
          <span class="font-style
          " v-if="scope.$index !== 0">{{ scope.row.sid }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="templateType == 0" :label="$t('lang.collect.endian')" min-width="150px">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0 && scope.row.endian">{{ endianObj[scope.row.endian] }}</span>
          <span class="font-style" v-else-if="scope.$index !== 0 && !scope.row.endian">-</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.collect.Reportingtype')" width="108px">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            triggerObj[scope.row.trigger]
          }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.collect.Reportingcycle')" sortable="custom" prop="interval" width="116px">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0 && scope.row.interval">{{ scope.row.interval +
            $t("lang.collect.second") }}</span>
          <span class="font-style" v-else-if="scope.$index !== 0 &&
            !scope.row.interval + $t('lang.collect.second')
            ">-</span>
        </template>
      </el-table-column>
      <!-- 暂时用不上，先隐藏 -->
      <el-table-column v-if="templateType == 0" :label="$t('lang.collect.calculationfactor')" width="122px">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.factor
          }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="templateType == 0" :label="$t('lang.collect.decimalprecision')" prop="precision"
        width="140px">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.precision
          }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="templateType == 1" :label="$t('lang.collect.IOcontrollertype')" prop="ioType" width="140px">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            ioTypeObj[scope.row.ioType]
          }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="templateType == 1" :label="$t('lang.collect.interfacenumber')" prop="number">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            ioTypeObj[scope.row.ioType] + scope.row.ioNumber
          }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.collect.functiontype')" width="120px" prop="funcType">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            templateType == 0
            ? modbusListObj[scope.row.funcType]
            : ioControlListObj[scope.row.funcType]
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column v-if="templateType==1" label="IO口状态" prop="state">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0"> {{scope.row.state}}</span>
        </template>
      </el-table-column>-->
      <!-- <el-table-column label="存储方式" prop="storageMode">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0"> {{storageModeObj[scope.row.storageMode]}}</span>
        </template>
      </el-table-column>
      <el-table-column label="读写方式">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0"> {{rorwObj[scope.row.rorw]}}</span>
        </template>
      </el-table-column>-->
      <el-table-column :label="$t('lang.collect.operate')" fixed="right" min-width="200px" align="center">
        <template slot-scope="scope">
          <div v-if="scope.$index !== 0">
            <el-button v-if="Permission.indexOf(248) !== -1" type="primary" icon="el-icon-edit" circle
              @click="editParams(scope.row)"></el-button>
            <el-button v-if="Permission.indexOf(250) !== -1" type="danger" icon="icon-lingdang" circle
              @click="setAlarm(scope.row)"></el-button>
            <el-button v-if="Permission.indexOf(249) !== -1" type="danger" icon="el-icon-delete" circle
              @click="removeParams(scope.row)"></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges">
    </pagination>-->
    <!-- 添加变量的表单 -->
    <params-form ref="paramsForm" :templateType="templateType" @updateList="getList"
      @setParamsIds="setParamsIds"></params-form>
    <set-alarm ref="setAlarm"></set-alarm>
  </div>
</template>
<script>
import {
  registerTypeObj,
  dataFormatObj,
  storageModeObj,
  rorwObj,
  dataTypeObj,
  endianObj,
  triggerObj,
  unitObj,
  unitOptions,
  ioControlListObj,
  modbusListObj,
  ioTypeObj,
} from "@/utils/paramsConfig";
import { PublicComponent } from "@/mixins/common";
import pagination from "@/components/pagination";
import TableComponent from "@/components/TableComponent/index";
import paramsForm from "./paramsForm";
import {
  getParams,
  deleteParams,
  monitorParams,
} from "@/api/cloudMonitor/paramsList";
import setAlarm from "./setAlarm";
import { getPermission } from "@/cookie/cookie";
export default {
  props: ["templateId", "Height", "templateType"],
  components: {
    TableComponent,
    pagination,
    paramsForm,
    setAlarm,
  },
  mixins: [PublicComponent],
  data() {
    return {
      registerTypeObj,
      ioControlListObj,
      modbusListObj,
      dataFormatObj,
      storageModeObj,
      ioTypeObj,
      dataTypeObj,
      endianObj,
      rorwObj,
      triggerObj,
      unitObj,
      paramsList: [],
      seek: {
        name: "",
        unit: "", // 变量单位
        registerType: 0, //寄存器类型
        registerAddress: "", // 寄存器地址
        dataFormat: "", // 变量类型
        registerNum: "", // 寄存器个数
        precision: "", // 小数精度
        storageMode: "", // 存储方式
        rorw: 0, // 读写方式
      },
      Permission: [],
      sortNum: 12
    };
  },
  watch: {
    templateId: {
      immediate: true,
      handler() {
        this.Permission = getPermission();
        if (this.templateId) {
          this.getList();
        }
      },
    },
  },
  filters: {
    unitFormat(e) {
      if (unitObj[e]) {
        return unitObj[e];
      } else {
        unitObj[e] = e;
        unitOptions.splice(unitOptions.length - 1, 0, {
          label: e,
          value: e,
        });
        return unitObj[e];
      }
    },
  },
  methods: {
    // 获取变量列表
    getList() {
      getParams(this.templateId, this.templateType ? this.templateType : "0", this.sortNum)
        .then((res) => {
          if (res.data.code === 0) {
            this.paramsList = res.data.data;
            this.paramsList.unshift({});
          }
        })
        .catch(() => { });
    },
    editParams(row) {
      console.log(row);
      this.$refs.paramsForm.show(row);
    },
    // 删除
    removeParams(row) {
      this.$confirm(
        this.$t("lang.collect.msg1"),
        this.$t("lang.collect.msg2"),
        {
          confirmButtonText: this.$t("lang.collect.msg3"),
          cancelButtonText: this.$t("lang.collect.Cancel"),
          type: "warning",
          center: true,
        }
      ).then(() => {
        deleteParams(row.id)
          .then((res) => {
            if (res.data.code === 0) {
              this.$message.success(this.$t("lang.collect.msg4"));
              let monitorData = {
                mid: row.mid,
                vids: [Number(row.id)],
                action: 2,
                type: this.templateType,
              };
              monitorParams(monitorData).then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(this.$t("lang.collect.msg5"));
                } else {
                  this.$message.error(this.$t("lang.collect.msg6"));
                }
              });
              this.offset = 1;
              this.getList();
            } else if (res.data.code === 48) {
              this.$message.error(this.$t("lang.collect.msg7"));
            } else {
              this.$message.error(this.$t("lang.collect.msg8"));
            }
          })
          .catch(() => { });
      });
    },
    setAlarm(row) {
      this.$refs.setAlarm.show(row);
    },
    // 缓存有变动的变量Id
    setParamsIds(val) {
      this.$emit("setParamsIds", val);
    },
    // addParams弹出添加表单
    addParams() {
      if (!this.templateId) {
        this.$message.warning(this.$t("lang.collect.msg9"));
      } else {
        this.$refs.paramsForm.show(this.templateId);
      }
    },
    computedAddress(row) {
      let prefix = "0";
      let str = "00000";
      let type = row.registerType;
      switch (type) {
        case 1:
          str = "00000";
          prefix = "0";
          break;
        case 2:
          str = "10000";
          prefix = "1";
          break;
        case 3:
          str = "40000";
          prefix = "4";
          break;
        case 4:
          str = "30000";
          prefix = "3";
          break;
        default:
          str = "00000";
          prefix = "0";
      }
      let addrStr = row.registerAddress ? row.registerAddress.toString() : "";
      if (addrStr.length >= 5) {
        return prefix + addrStr;
      } else {
        let l = str.length - addrStr.length;
        return str.slice(0, l) + addrStr;
      }
    },
    tableSort(e) {
      if (e.order === null) this.sortNum = 12
      switch (e.prop) {
        case 'name':
          if (e.order === 'ascending') {
            this.sortNum = 1
          } else {
            this.sortNum = 2
          }
          break;
        case 'uint':
          if (e.order === 'ascending') {
            this.sortNum = 3
          } else {
            this.sortNum = 4
          }
          break;
        case 'registerAddress':
          if (e.order === 'ascending') {
            this.sortNum = 5
          } else {
            this.sortNum = 6
          }
          break;
        case 'sid':
          if (e.order === 'ascending') {
            this.sortNum = 7
          } else {
            this.sortNum = 8
          }
          break;
        case 'interval':
          if (e.order === 'ascending') {
            this.sortNum = 9
          } else {
            this.sortNum = 10
          }
          break;
      }
      this.getList()
    }
  },
};
</script>
<style scoped>
.font-style {
  font-size: 0.25rem;
}
</style>
